import type { ClientAgreementRow } from 'types';

export const ASSESSMENT_RETAINER_RESOURCE = 'ASSESSMENT_RETAINER_AGREEMENT';

export const isAssessmentAgreement = (row: ClientAgreementRow): boolean =>
    row.resource_type === ASSESSMENT_RETAINER_RESOURCE;

export const isAgreementSigned = (row: ClientAgreementRow): boolean =>
    Boolean(row.candidate_signed_date);

/** Unsigned visa agreements can be emailed again. Assessment rows have no application id. */
export const canResendAgreement = (row: ClientAgreementRow): boolean =>
    !isAgreementSigned(row) && row.application_id != null;

export const canDeleteAgreement = (row: ClientAgreementRow): boolean => row.agreement_id != null;

export const canOpenAgreementMilestones = (row: ClientAgreementRow): boolean =>
    row.application_id != null;
